// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"167":"select","286":"game-welcome","332":"instructions","485":"game","774":"mode"}[chunkId] + "." + {"167":"edff665b","286":"d6db30b1","332":"bef31d87","485":"02c79119","774":"764fbc1b"}[chunkId] + ".css";
};